import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../context/LanguageContext';
import { ReactComponent as Logo } from '../../assets/site-assets/logo-primary.svg';
import './Header.scss';


const languages = [
  { code: 'en', labelKey: 'language.english' },
  { code: 'ar', labelKey: 'language.arabic'  },
];

const Header = () => {
  const { t } = useTranslation();
  const { lang, setLang } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const langRef = useRef(null);

  const activeLang = languages.find((l) => l.code === lang) || languages[0];

  const navItems = [
    {
      key:      'navigation.experience',
      href:     lang === 'ar' ? 'https://www.visitsharjah.com/ar/' : 'https://visitsharjah.com',
      external: true,
    },
    { key: 'navigation.work',     href: '/live'     },
    { key: 'navigation.study',    href: '/study'    },
    { key: 'navigation.invest',   href: '/invest'   },
    { key: 'navigation.services', href: '/services' },
    {
      key:      'navigation.events',
      href:     lang === 'ar' ? 'https://sharjahevents.ae/ar' : 'https://sharjahevents.ae/en',
      external: true,
    },
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (langRef.current && !langRef.current.contains(e.target)) {
        setLangOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectLang = (langItem) => {
    setLang(langItem.code);
    setLangOpen(false);
  };

  return (
    <header className="header">
      <div className="header__inner">
        <a href="/" className="header__logo">
          <Logo />
        </a>

        <nav className={`header__nav${menuOpen ? ' header__nav--open' : ''}`}>
          <ul className="header__menu">
            {navItems.map((item) => (
              <li key={item.href} className="header__menu-item">
                <a
                  href={item.href}
                  className={`header__badge${!item.external && window.location.pathname === item.href ? ' active' : ''}`}
                  {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                >
                  {t(item.key)}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="header__right">
          {/* Language switcher */}
          <div className="lang-switcher" ref={langRef}>
            <button
              className="lang-switcher__trigger"
              onClick={() => setLangOpen((v) => !v)}
              aria-haspopup="listbox"
              aria-expanded={langOpen}
            >
              {t(activeLang.labelKey)}
              <svg
                className={`lang-switcher__chevron${langOpen ? ' lang-switcher__chevron--up' : ''}`}
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            {langOpen && (
              <ul className="lang-switcher__dropdown" role="listbox">
                {languages.map((langItem) => (
                  <li
                    key={langItem.code}
                    className={`lang-switcher__option${activeLang.code === langItem.code ? ' lang-switcher__option--active' : ''}`}
                    role="option"
                    aria-selected={activeLang.code === langItem.code}
                    onClick={() => selectLang(langItem)}
                  >
                    {t(langItem.labelKey)}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Mobile burger */}
          <button
            className={`header__burger${menuOpen ? ' header__burger--open' : ''}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={t('navigation.toggleMenu')}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
